module.exports = __webpack_public_path__ + "static/media/Announce.cf8c92e1.svg";